import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/Header/Header";
import s from "./ManagerEmployees.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getManagerEmployeesList,
  setManagerEmployeesCurrentPage,
} from "../../redux/UserSlice";
import { IManagerEmployeeResponseResults } from "../../types";
import Footer from "../../components/Footer/Footer";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import MobileUsersListTable from "../MobileUsersListTable/MobileUsersListTable";
import { useTranslation } from "react-i18next";
import { UserTable } from "../../components/Tables/UserTable";

const ManagerEmployees = () => {
  const users = useSelector((state: RootState) => state.user.managerUsersList);

  const { t } = useTranslation();
  const dispatch: AppDispatch = useDispatch();
  const { width } = useWindowDimensions();
  const employeeCurrentPage = useSelector(
    (state: RootState) => state.user.managerEmployeesListCurrentPage
  );

  const [pagination, setPagination] = useState({
    current: users?.pagination?.current_page || 1,
    pageSize: users?.pagination?.page_size || 20,
    total: users?.pagination?.total_pages || 100,
  });
  const [currentPage, setCurrentPage] = useState<number>(
    employeeCurrentPage || 1
  );

  const [data, setData] = useState<
    IManagerEmployeeResponseResults[] | undefined
  >(users?.results);

  const currentPageRef = useRef(currentPage);

  useEffect(() => {
    currentPageRef.current = currentPage;
    dispatch(setManagerEmployeesCurrentPage(currentPage));
  }, [dispatch, currentPage]);

  useEffect(() => {
    if (users?.results) {
      setData(users.results);
      setPagination({
        current: users.pagination?.current_page || 1,
        pageSize: users.pagination?.page_size || 20,
        total: users.pagination?.total_items || 0,
      });
    }
  }, [users]);

  const getNextPage = async (page: number) => {
    setCurrentPage(page);
    dispatch(setManagerEmployeesCurrentPage(page));

    currentPageRef.current = page;

    if (page === undefined || page === null) return;

    try {
      const res = await dispatch(getManagerEmployeesList(page));
      if (!res.payload || !("results" in res.payload)) {
        console.error("Unexpected API response:", res);
        return;
      }

      if (res.type === "users/getManagerEmployeesList/fulfilled") {
        if ("results" in res.payload) {
          setData(res.payload.results);
          setPagination({
            current: res?.payload?.pagination?.current_page,
            pageSize: res?.payload?.pagination.page_size,
            total: res.payload.pagination.total_items,
          });
        } else {
          console.error("Unexpected API response:", res.payload);
        }
      }
    } catch (error) {
      console.error("Error in getNextPage:", error);
    }
  };

  return (
    <div>
      {width > 985 ? <Header /> : <MobileHeader />}
      <div className={s.content}>
        <h2 className={s.h2}>{t("Поставщики услуг")}</h2>
        <div className={s.users}>
          {width > 750 ? (
            <UserTable
              pagination={{
                ...pagination,
                size: width > 900 ? "default" : "small",
              }}
              dataSource={data ? data : undefined}
              onPageChange={(pagination) => {
                getNextPage(pagination);
              }}
            />
          ) : (
            <MobileUsersListTable />
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ManagerEmployees;
